import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
import { DailyLessonStatusKollegeExpenseRecordDailyLessonInputFragmentDoc } from './DailyLessonStatus/DailyLessonStatus.generated';
import { DailyLessonInstructorCommentModalKollegeUserFragmentDoc } from './DailyLessonInstructorCommentModal/DailyLessonInstructorCommentModal.generated';
export type DailyLessonCardKollegeExpenseRecordDailyLessonInputFragment = { __typename?: 'KollegeExpenseRecordDailyLessonInput', guid: string, title: string, nth_day: number, instructorComment?: string | null, state: Types.KollegeExpenseRecordDailyLessonInputState };

export type DailyLessonCardKollegeUserFragment = { __typename?: 'KollegeUser', id: string, profile?: { __typename?: 'KollegeUserProfile', familyName: string, givenName: string } | null };

export const DailyLessonCardKollegeExpenseRecordDailyLessonInputFragmentDoc = gql`
    fragment DailyLessonCardKollegeExpenseRecordDailyLessonInput on KollegeExpenseRecordDailyLessonInput {
  guid
  title
  nth_day
  instructorComment
  ...DailyLessonStatusKollegeExpenseRecordDailyLessonInput
}
    ${DailyLessonStatusKollegeExpenseRecordDailyLessonInputFragmentDoc}`;
export const DailyLessonCardKollegeUserFragmentDoc = gql`
    fragment DailyLessonCardKollegeUser on KollegeUser {
  ...DailyLessonInstructorCommentModalKollegeUser
}
    ${DailyLessonInstructorCommentModalKollegeUserFragmentDoc}`;